



































import Vue from 'vue';
import ImageInfo from '@/types/ImageInfo';

export default Vue.extend({
    name: 'ImageDisplayer',

    props: {
        image: Object as () => ImageInfo,
        showUp: {
            type: Boolean,
            default: false
        },
        showDown: {
            type: Boolean,
            default: false
        }
    }
});
